import React, { Component } from 'react'
import {
	RefreshIcon,
	ClockIcon } from '@heroicons/react/outline'
import InfoTip from './InfoTip'

class StatsContextCard extends Component {
	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse h-full">
					<div className="h-3 bg-slate-200 rounded-full w-1/2 mb-5"></div>
					<div className="h-8 bg-slate-200 rounded-lg w-1/3 mb-5"></div>
					<div className="h-16 bg-slate-100 rounded-xl"></div>
				</div>
			)
		}
		if (this.props.error === true || !this.props.context)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Activité par heure</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center gap-1.5 px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						<RefreshIcon className="w-4 h-4" aria-hidden="true" />
						Réessayer
					</button>
				</div>
			)
		}
		const hourly = (this.props.context.hourly && this.props.context.hourly.length === 24) ? this.props.context.hourly : null
		const peakHour = this.props.context.peakHour
		const peakLabel = (peakHour === null || peakHour === undefined) ? null : (peakHour + 'h–' + ((peakHour + 1) % 24) + 'h')
		const max = hourly ? Math.max.apply(null, hourly.concat([1])) : 1
		const axis = [0, 6, 12, 18, 23]
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
				<div className="flex items-center justify-between mb-4">
					<span className="inline-flex items-center gap-1">
						<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Activité par heure</h2>
						<InfoTip text="À quelles heures vos campeurs sont les plus nombreux à utiliser l'app. Utile pour choisir quand envoyer une notification." />
					</span>
					<div className="w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
						<ClockIcon className="w-5 h-5 text-amber-600" aria-hidden="true" />
					</div>
				</div>
				{(!hourly || max <= 1)
					? <p className="text-sm font-medium text-slate-500 my-0">Pas assez de données sur cette période.</p>
					: (
						<div>
							<div className="flex items-baseline gap-2">
								<p className="text-3xl font-black text-slate-900 my-0 leading-none">{peakLabel}</p>
								<span className="text-2xs font-bold text-slate-400 uppercase tracking-widest">heure de pointe</span>
							</div>
							<div
								className="flex items-end gap-px h-16 mt-4"
								role="img"
								aria-label={'Répartition des visites par heure. Pic à ' + (peakLabel || '')}
							>
								{hourly.map((count, h) => {
									const pct = Math.round((count / max) * 100)
									const isPeak = (h === peakHour)
									return (
										<div
											key={h}
											className={'flex-1 rounded-sm ' + (isPeak ? 'bg-indigo-500' : 'bg-slate-200')}
											style={{ height: Math.max(pct, count > 0 ? 4 : 0) + '%' }}
											title={h + 'h : ' + count}
										></div>
									)
								})}
							</div>
							<div className="flex justify-between mt-1.5">
								{axis.map(h => (
									<span key={h} className="text-2xs font-semibold text-slate-400">{h}h</span>
								))}
							</div>
							<p className="text-2xs font-medium text-slate-400 my-0 mt-3">Idéal pour programmer l'envoi d'une notification</p>
						</div>
					)
				}
			</div>
		)
	}
}

export default StatsContextCard
